var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ei-home-body"},[_c('div',{ref:"bodyOne",staticClass:"body-one"},[_vm._t("one")],2),_c('div',{ref:"bodyTwo",class:{'body-two':true,'cover':_vm.cover},attrs:{"id":"bodyTwo"}},[_vm._t("two")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }